import * as OrderAction from "./OrderAction";

export default function orderReducer(state = {}, action) {
    switch (action.type) {
        case OrderAction.REQUEST_USER_ORDERS_FINISHED:
            // TODO: handle errors
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    currentUser: {
                        ...action.payload
                    }
                };
            }

        case OrderAction.REQUEST_ALL_ORDERS_FINISHED:
            // TODO: handle errors
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    all: {
                        ...action.payload
                    }
                };
            }

        case OrderAction.REQUEST_ALL_ORDERS_BASIC_FINISHED:
            // TODO: handle errors
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    allBasic: {
                        ...action.payload
                    }
                };
            }

        case OrderAction.REQUEST_SPECIFIC_ORDER_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    requestedOrder: {
                        ...action.payload
                    }
                };
            }
        
        case OrderAction.CREATE_EMPTY_ORDER_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    newOrderId: action.payload.orderId
                };
            }
        
        case OrderAction.DELETE_ORDER_ID_FROM_STATE:
            return {
                ...state,
                newOrderId: null
            }

        default:
            return state;
    }
}
